import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: null
  },
  getters: {
  },
  mutations: {
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    }
  },
  actions: {
    onLoading(context, isLoading) {
      context.commit('setLoading', isLoading);
    }
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js